<template>
  <div>
    <!-- Modal bookModal -->
    <div class="modal fade text-left text-black" id="bookModal" ref="bookModal" tabindex="-1" data-backdrop="static" aria-labelledby="bookingLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div v-if="'BOOKING' == state" class="modal-content">

          <div class="modal-header">
            <h4 class="modal-title" :class="$deploymentIs('cryptology') ? 'heading' : ''" id="bookingLabel">{{ location.brand }} <span v-if="fromVirtualGame">Virtual Game</span><span v-else>Room</span> Booking</h4>
            <button type="button" class="close btn-red" data-dismiss="modal" aria-label="Close">
              <h4 aria-hidden="true">&times;</h4>
            </button>
          </div>

          <div class="modal-body">
            <div class="row mb-2">
              <div class="col-sm-8">
                <h5>You have selected:</h5>

                <template v-if="fromVirtualGame">
                  <h3 id="modal-room-name" :class="$deploymentIs('cryptology') ? 'heading' : ''">{{ room.name }}</h3>
                </template>
                <template v-else>
                  <h3 id="modal-room-name" :class="$deploymentIs('cryptology') ? 'heading' : ''">{{ room.name }}</h3>
                  <h4 :class="$deploymentIs('cryptology') ? 'font-mon' : ''" :style="$deploymentIn(['breakescape', 'taketheexit']) ? 'letter-spacing: 0;' : ''">
                    <span id="modal-room-date">
                      {{ roomSlot.start | moment('ddd Do MMM YYYY') }}</span> @ <span id="modal-room-time">{{ roomSlotTimeText }}
                    </span>
                  </h4>

                  <h5 v-if="roomSlot.public_booking">
                    <span class="material-icons" style="position: relative; top: 6px;">screen_lock_landscape</span> {{ roomSlot.availableRemainingTickets }} of {{ roomSlot.override_play_max ? roomSlot.override_play_max : room.play_max}} tickets remaining &mdash; Public Booking
                  </h5>
                  <h5 v-if="room.nickname == 'area515' && (numberOfAdults == 2 || numberOfAdults == 3)" class="text-tempus-blue-200">
                    <span class="material-icons">lock_clock</span> This is a 75 minute game for 2s or 3s
                  </h5>
                  <h5 v-if="room.duration != 60" class="text-tempus-blue-200">
                    <template v-if="room.nickname == 'mgcshw'">
                      <span class="material-icons" style="position: relative; top: 6px;">lock_clock</span> This is a {{ room.duration }} minute Magic Show
                    </template>
                    <template v-else>
                      <span class="material-icons" style="position: relative; top: 6px;">lock_clock</span> This is a {{ room.duration }} minute game
                    </template>
                  </h5>
                  <h6 v-if="room.room_address">
                    <span class="material-icons" style="position: relative; top: 6px;">not_listed_location</span> {{ room.room_address }}
                  </h6>

                  <h6 v-if="$deploymentIs('breakescape')">
                    <template v-if="location.slug == 'loughborough'">
                      <span class="material-icons" style="position: relative; top: 6px;">not_listed_location</span> 58/59 Baxter Gate, Loughborough, LE11 1TH
                    </template>
                    <template v-else>
                      <span class="material-icons" style="position: relative; top: 6px;">not_listed_location</span> 9a Market Street, Nottingham, NG1 6HY
                    </template>
                  </h6>
                </template>

              </div>
              <div class="col-sm-4">
                <img id="room_mp" :src="'/img/mp/mp-ls-' + room.nickname + '.jpg'" class="img-fluid">
              </div>
            </div>

            <div v-if="! fromVirtualGame" class="form-group row">
              <template v-if="pricingStyle == 'CHILD_TOTAL_PLAYERS'">
                <div class="col">
                  <label class="col-form-label"><sup class="text-red font-weight-bold" data-toggle="tooltip" title="Required">(*)</sup> {{ bookingLabelAdults }}:</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <button
                        class="btn btn-red"
                        type="button"
                        :disabled="numberOfPlayers <= room.play_min"
                        @click="numberOfAdults = numberOfAdults - 1">&minus;</button>
                    </div>
                    <input
                      type="number"
                      min="1"
                      class="form-control"
                      disabled="disabled"
                      v-model.number="numberOfAdults">
                    <div class="input-group-append">
                      <button
                        class="btn btn-green"
                        type="button"
                        :disabled="roomSlot.availableRemainingTickets - numberOfPlayers == 0"
                        @click="numberOfAdults = numberOfAdults + 1">&plus;</button>
                    </div>
                  </div>
                </div>
                <div class="col input-group">
                  <label class="col-form-label">Children</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <button
                        class="btn btn-red"
                        type="button"
                        :disabled="numberOfPlayers <= room.play_min"
                        @click="numberOfChildren = numberOfChildren - 1">&minus;</button>
                    </div>
                    <input
                      type="number"
                      min="1"
                      class="form-control"
                      disabled="disabled"
                      v-model.number="numberOfChildren">
                    <div class="input-group-apppend">
                      <button
                        class="btn btn-green"
                        type="button"
                        :disabled="roomSlot.availableRemainingTickets - numberOfPlayers == 0"
                        @click="numberOfChildren = numberOfChildren + 1">&plus;</button>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 mt-2">
                  <p class="mb-0">
                    <span class="col-form-label">Experience Cost:</span>

                    <span v-if="numberOfPlayers >= room.play_min" class="font-weight-bold">{{ getPrice(numberOfAdults, numberOfChildren) | money }}</span>
                    <span v-else class="font-weight-bold font-italic">Please add more players to your experience</span>
                  </p>
                </div>
              </template>

              <template v-else-if="hasChildPricing && ! room.pricing_disable_child">
                <label :for="$id('numberOfAdults')" class="col-sm-2 col-form-label pt-0"><sup class="text-red font-weight-bold" data-toggle="tooltip" title="Required">(*)</sup> {{ bookingLabelAdults }}:</label>
                <div class="col-sm-4">
                  <select-two
                    ref="numPlayersInput"
                    :id="$id('numberOfAdults')"
                    v-model="numberOfAdults"
                    :settings="{minimumResultsForSearch: Infinity, width: '100%', dropdownParent: $refs.bookModal}"
                    :options="numPlayersInputOptions"
                    :placeholder="bookingLabelAdultsSelection"
                    :invalid="numberOfAdultsError"
                    required>
                    <option value=""></option> <!-- Required for placeholder to work-->
                  </select-two>
                </div>
                <label :for="$id('numberOfChildren')" class="col-sm-2 col-form-label pt-0">Children</label>
                <div class="col-sm-4">
                  <select-two
                    ref="numPlayersInput"
                    :id="$id('numberOfChildren')"
                    v-model="numberOfChildren"
                    :settings="{minimumResultsForSearch: Infinity, width: '100%', dropdownParent: $refs.bookModal}"
                    :options="numChildrenInputOptions"
                    :disabled="numberOfAdults < 2"
                    placeholder="Select number of children"
                    :invalid="numberOfChildrenError">
                    <option value="0">0 children</option> <!-- Required for placeholder to work-->
                  </select-two>
                </div>
                <label class="col-sm-12 col-form-label pt-0 font-italic">{{ bookingChildCaveat }}</label>
                <label v-if="$deploymentIs('escapable') && hasChildPricing && (room.nickname == 'loudini' || room.nickname == 'loupuzz')" class="col-sm-12 col-form-label pt-0 font-italic text-deep-orange">Children under 13 are not allowed to participate in The Great Loudini, and we do not accommodate children's parties in this game. Therefore, children's pricing is the same as adults.</label>
              </template>
              <template v-else>
                <label :for="$id('numberOfAdults')" class="col-sm-2 col-form-label pt-0"><sup class="text-red font-weight-bold" data-toggle="tooltip" title="Required">(*)</sup> <template v-if="room && room.options && room.options.event">Guests</template><template v-else>Players</template></label>
                <div class="col-sm-10">
                  <select-two
                    ref="numPlayersInput"
                    :id="$id('numberOfAdults')"
                    v-model="numberOfAdults"
                    :settings="{minimumResultsForSearch: Infinity, width: '100%', dropdownParent: $refs.bookModal}"
                    :options="numPlayersInputOptions"
                    :placeholder="room && room.options && room.options.event ? 'Select number of guests' : 'Select number of players'"
                    :invalid="numberOfPlayersError"
                    required>
                    <option value=""></option> <!-- Required for placeholder to work-->
                  </select-two>
                </div>
              </template>
            </div>

            <div class="form-group row">
              <label :for="$id('email')" class="col-sm-2 col-form-label pt-0"><sup class="text-red font-weight-bold" data-toggle="tooltip" title="Required">(*)</sup> Email</label>
              <div class="col-sm-10">
                <input type="email"
                  :id="$id('email')"
                  class="form-control"
                  :class="{'is-invalid': emailError}"
                  placeholder="If you have already booked before, your email will populate the rest"
                  v-model="email"
                  @blur='emailBlur'
                  autocomplete="email"
                  required>
                <div v-if="emailError" class="invalid-feedback d-block" role="alert">{{ emailError }}</div>
                <div v-if="emailSoftError" class="text-orange font-weight-bold d-block" role="alert">{{ emailSoftError }}</div>
              </div>
            </div>

            <div class="form-group row">
              <label :for="$id('name')" class="col-sm-2 col-form-label pt-0"><sup class="text-red font-weight-bold" data-toggle="tooltip" title="Required">(*)</sup> Name</label>
              <div class="col-sm-10">
                <input type="text"
                  :id="$id('name')"
                  ref="nameInput"
                  class="form-control"
                  :class="{'is-invalid': nameError}"
                  v-model="name"
                  placeholder="Full name for booking"
                  autocomplete="name"
                  required>
                <div v-if="nameError" class="invalid-feedback d-block" role="alert">{{ nameError }}</div>
              </div>
            </div>

            <div class="form-group row" style="display: none;">
              <label :for="$id('username')" class="col-sm-2 col-form-label"><sup class="text-red font-weight-bold" data-toggle="tooltip" title="Required">(*)</sup> Username</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  :id="$id('username')"
                  class="form-control"
                  v-model="username"
                  placeholder="Username"
                  autocomplete="off">
              </div>
            </div>

            <div class="form-group row">
              <label :for="$id('contactNumber')" class="col-sm-2 col-form-label pt-0">
                <sup
                  v-if="this.location.formCustomerNumberRequired"
                  class="text-red font-weight-bold"
                  data-toggle="tooltip"
                  title="Required">
                  (*)
                </sup>
                 Contact Number
               </label>
              <div class="col-sm-10">
                <input type="tel"
                  :id="$id('contactNumber')"
                  ref="customerTelephoneInput"
                  class="form-control"
                  :class="{'is-invalid': contactNumberError}"
                  v-model="contactNumber"
                  placeholder="Contact number"
                  autocomplete="tel"
                  required>
                <div v-if="contactNumberError" class="invalid-feedback d-block" role="alert">{{ contactNumberError }}</div>
              </div>
            </div>

            <div v-if="customerRequestMarketingPermission" class="form-group row">
              <div class="checkboxdiv ml-2">
                <label :for="$id('marketing_consent')" class="ml-2">I give consent to receive additional marketing</label>
                <label class="checkboxdiv-label-md ml-2">
                  <input
                    type="checkbox"
                    :id="$id('marketing_consent')"
                    v-model="marketingConsent">
                  <span class="cr"><span class="cr-icon">&#10004;</span></span>
                </label>
              </div>
            </div>

            <div v-if="! fromVirtualGame && room.live_actor" class="alert alert-success" role="alert">
              <div class="input-group input-group-lg">
                <p class="mb-0">This is not like a standard escape room, it features a live actor. Please ensure you and your team have read the FAQs relating to this game.</p>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <span v-if="! enoughPlayersToProceed" class="text-red font-italic">More players are required to proceed&hellip;</span>
            <button type="button" class="btn btn-danger" data-dismiss="modal" id="diffSlot">
              <span v-if="fromVirtualGame">Cancel</span>
              <span v-else>Choose a different slot</span>
            </button>

            <button v-if="! fromVirtualGame && room && room.room_questions.length" id="roomQuestionResponses" :disabled="! enoughPlayersToProceed" type="button" class="btn btn-green" @click="respondToRoomQuestionsClick">
              Next Step
            </button>
            <button v-else id="makeBookingConfirmPriceBtn" :disabled="! enoughPlayersToProceed" type="button" class="btn btn-green" @click="confirmPriceClick">
              Confirm Price
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- .modal bookModal -->

    <!-- Modal lockModal -->
    <div class="modal fade" ref="lockModal" tabindex="-1" aria-labelledby="lockedLabel" data-backdrop="static" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div v-if="'LOCKED' == state" class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title text-black heading" id="lockedLabel">{{ location.brand }} Room Booking Locked</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <h4 aria-hidden="true">&times;</h4>
            </button>
          </div>
          <div class="modal-body text-black">
            <h3 class="mb-2">
              This slot is currently reserved for {{ slotLockLength }} as somebody is trying to book it.
            </h3>
            <h4 class="mb-2">
              If this is you, enter your email to continue with your booking.
            </h4>
            <h4 class="mb-2">
              If you wish to revise the number of players, enter your email and click <span class="text-danger">Remove Lock</span>
            </h4>
            <div class="alert alert-danger" role="alert">
              <p><strong>Is this you?</strong> Enter your email address to continue or remove the lock to change the booking</p>
              <div class="input-group input-group-lg">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="lockEmail-addon">@</span>
                </div>
                <input
                  type="email"
                  class="form-control"
                  placeholder="Email address"
                  v-model="lockEmail"
                  aria-label="Email address"
                  aria-describedby="lockEmail-addon">
              </div>
            </div>
            <div id="lockError"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" @click="destroyRoomSlotLock">
              Remove Lock
            </button>
            <button type="button" class="btn btn-primary" @click="lockProceed">
              Proceed to payment
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- .modal lockModal -->

    <!-- Modal confirmModal -->
    <div class="modal fade text-left text-black" ref="confirmModal" tabindex="-1" aria-labelledby="payLabel" data-backdrop="static" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div v-if="'CONFIRMING' == state" class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title font-weight-bold" id="payLabel">{{ location.brand }} Payment</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body" ref="confirmModalBody">
            <div class="row">
              <div class="col">
                <input id="payEmail" type="hidden">
                <div class="alert alert-info" role="alert">
                  <h4>You are about to book&hellip;</h4>
                  <ul>
                    <li><strong>Game:</strong> <span>{{ room.name }}</span></li>
                    <template v-if="! fromVirtualGame">
                      <li v-if="room.duration != 60"><strong>Time Limit:</strong> <span>{{ room.duration }} minutes</span></li>
                      <li><strong>On:</strong> <span>{{ roomSlot.start | moment('dddd Do MMMM YYYY') }}</span></li>
                      <li><strong>At:</strong> <span>{{ roomSlotTimeText }}</span></li>
                      <li><strong>For:</strong> <span v-if="numberOfChildren">{{ numberOfAdults }} adults &plus; {{ numberOfChildren == 1 ? '1 child' : numberOfChildren + ' children' }}</span><span v-else>{{ numberOfAdults }} players</span></li>
                    </template>
                    <template v-else>
                      <li><strong>On:</strong> <span>A time of your choosing</span></li>
                      <li><strong>With:</strong> <span>72 hours to complete the game once started</span></li>
                      <li><strong>For:</strong> <span>Up to 6 remote players</span></li>
                    </template>
                  </ul>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="alert alert-green" role="alert">
                  <div class="input-group input-group-lg">
                    <h4 :style="$deploymentIn(['breakescape', 'taketheexit']) ? 'letter-spacing: 0;' : ''">
                      <template v-if="fromVirtualGame">
                        <p class="mb-0">Total Cost: <strong>{{ getPrice(numberOfAdults, numberOfChildren) | money }}</strong></p>
                      </template>
                      <template v-else>
                        <p class="mb-0">Total Cost: <strong>{{ getPrice(numberOfAdults, numberOfChildren) | money }}</strong></p>
                        <p v-if="room.duration != 60" class="text-tempus-blue-200 mt-2 mb-0">As this is a {{ room.duration }} minute game, pricing may be different than 60 minute pricing.</p>
                      </template>
                    </h4>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="alert alert-primary text-center" role="alert" style="padding-top: 6px; padding-bottom: 6px;">
                  <div class="row">
                    <div class="col btn-group">

                      <button type="button"
                        class="btn btn-lg btn-purple"
                        @click="addToCartButtonClicked(false)"
                        :disabled="payButtonDisable">
                        <span style="position: relative; top: -2px;">
                          Add To Cart <span class="material-icons" style="position: relative; top: 5px;">add_shopping_cart</span>
                        </span>
                      </button>
                      <button type="button"
                        class="btn btn-lg btn-green"
                        @click="addToCartButtonClicked(true)"
                        :disabled="payButtonDisable"
                        >Add &amp; Checkout <span class="material-icons">shopping_cart_checkout</span>
                      </button>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div v-if="asPendingError" class="alert alert-danger" role="alert" id="slot_book_lock">
                  <div class="input-group">
                    <p>{{ asPendingError }}</p>
                    <button type="button" class="btn btn-danger btn-block" data-dismiss="modal">
                      <span v-if="fromVirtualGame">Choose a different game</span>
                      <span v-else>Choose a different slot</span>
                    </button>
                  </div>
                </div>
                <div class="alert alert-warning" role="alert" id="slot_book_lock">
                  <div style="font-size: 0.75em; color: black !important;">
                    <template v-if="fromVirtualGame">
                      <p style="color: black !important;">By adding to a cart or clicking Checkout, once payment is complete you will be sent a link to your email address.</p>
                      <p style="color: black !important;">The game can be played from the same link by 6 different computers. Once you have started the game you must complete it within 72 hours.</p>
                    </template>
                    <template v-else-if="$deploymentIs('cryptology')">
                      <p v-if="room.caveat" class="text-red font-weight-bold" v-html="room.caveat"></p>

                      <p>By adding to a cart your booking will only be reserved to you when you start the checkout process. Once you attempt payment you will have all items in your basket reserved to you for 15 minutes. Please complete the payment process in this time.</p>
                      <p class="mb-0">
                        <template v-if="inPromo">Auto-discount will be applied in checkout, discount</template>
                        <template v-else>Discount</template>
                        and/or voucher codes can be redeemed in checkout.
                      </p>
                    </template>
                    <template v-else>
                      <p v-if="room.slug == 'mystical-creatures' || room.slug == 'elixir-vitae'" class="text-red font-weight-bold">This game can be played as a verses game for up to 12 players. Please get in touch if you want to do this.</p>
                      <p v-if="room.caveat" class="text-red font-weight-bold" v-html="room.caveat"></p>
                      <p>By adding to a cart your booking will only be reserved to you when you start the checkout process. Once you attempt payment you will have all items in your basket reserved to you for 15 minutes. Please complete the payment process in this time.</p>
                      <p class="mb-0" :class="inPromo ? 'text-dark-red font-weight-bold' : ''">
                        <template v-if="inPromo">{{ locationDiscount.percentage }}% auto-discount will be applied in checkout, other discount</template>
                        <template v-else>Discounts</template>
                        and/or voucher codes can be redeemed in checkout.
                      </p>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <img
              v-if="paymentProvider == 'Paymentsense' || paymentProvider == 'Paymentsense ConnectE'"
              class="img-fluid"
              style="margin: 0 auto;"
              src="/img/payment/payments_ps.png"
              alt="Payment Method Accepted">
            <img
              v-else-if="paymentProvider == 'Stripe'"
              class="img-fluid"
              style="margin: 0 auto;"
              src="/img/payment/payments_stripe.png"
              alt="Payment Method Accepted">
            <img
              v-else-if="paymentProvider == 'Square'"
              class="img-fluid"
              style="margin: 0 auto;"
              src="/img/payment/payments_square.png"
              alt="Payment Method Accepted">
            <img
              v-else
              class="img-fluid"
              style="margin: 0 auto;"
              src="/img/payment/payments_testing.png"
              alt="Payment Method Accepted">
          </div>
        </div>
      </div>
    </div>
    <!-- .modal confirmModal-->

    <!-- Modal roomQuestionModal -->
    <div class="modal fade text-left text-black" ref="roomQuestionModal" tabindex="-1" aria-labelledby="roomQuestionsLabel" data-backdrop="static" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title font-weight-bold" id="roomQuestionsLabel">{{ room ? room.name : '' }} Confirmations</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="alert" :class="room ? 'alert-' + room.nickname : ''">
              <h5 class="font-weight-bold">This Game has some additional questions/items of notes before you can proceed to book</h5>
            </div>

            <template v-if="! fromVirtualGame && room && room.room_questions.length">
              <hr/>
              <template v-for="question in room.room_questions">
                <div v-if="question.type == 'CHECKBOX'">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          :class="{'is-invalid': roomQuestionResponseError[question.id]}"
                          type="checkbox"
                          :id="$id('question' + question.id)"
                          v-model="roomQuestionResponses[question.id]" value="1">
                        <label class="form-check-label font-weight-bold" :for="$id('question' + question.id)" >
                          <sup v-if="question.required" class="text-red" data-toggle="tooltip" title="Required">(*)</sup>
                          {{ question.question }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <hr/>
                </div>
                <div v-else-if="question.type == 'RADIO'">
                  <div class="row">
                    <div class="col">
                      <p class="h5 font-weight-bold">
                        <sup v-if="question.required" class="text-red" data-toggle="tooltip" title="Required">(*)</sup>
                      {{ question.question }}
                      </p>
                      <div v-for="(answer, key) in question.answer_options" class="form-check" :key="key" :class="{'is-invalid': roomQuestionResponseError[question.id]}">
                        <input
                          class="form-check-input"
                          :class="{'is-invalid': roomQuestionResponseError[question.id]}"
                          type="radio"
                          :id="$id('answer' + key)"
                          v-model="roomQuestionResponses[question.id]"
                          :value="answer"
                          :required="question.required">
                        <label class="form-check-label" :for="$id('answer' + key)">
                          {{ answer }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <hr/>
                </div>
                <div v-else-if="question.type == 'DROPDOWN'">
                  <div class="form-group row">
                    <label :for="$id('question' + question.id)" class="col-sm-6 col-form-label font-weight-bold">
                      <sup v-if="question.required" class="text-red" data-toggle="tooltip" title="Required">(*)</sup>
                      {{ question.question }}
                    </label>
                    <div class="col-sm-6">
                      <select v-model="roomQuestionResponses[question.id]" class="form-control" :class="{'is-invalid': roomQuestionResponseError[question.id]}" :required="question.required">
                        <option :value="null">&lt;-- SELECT --&gt;</option>
                        <option v-for="answer in question.answer_options" :id="$id('question' + question.id)" :value="answer">{{ answer }}</option>
                      </select>
                    </div>
                  </div>
                  <hr/>
                </div>
                <div v-else-if="question.type == 'FREETEXT'">
                  <div class="form-group row">
                    <label :for="$id('question' + question.id)" class="col-sm-6 col-form-label font-weight-bold">
                      <sup v-if="question.required" class="text-red" data-toggle="tooltip" title="Required">(*)</sup>
                      {{ question.question }}
                    </label>
                    <div class="col-sm-6">
                      <textarea
                        v-model="roomQuestionResponses[question.id]"
                        class="form-control"
                        :class="{'is-invalid': roomQuestionResponseError[question.id]}"
                        rows="4"
                        :required="question.required"></textarea>
                    </div>
                  </div>
                  <hr/>
                </div>
              </template>
            </template>
            <p v-if="roomQuestionResponseErrors" class="font-weight-bold text-red"><span class="material-icons text-orange">warning</span> {{ roomQuestionResponseErrors }}</p>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-red" @click="hideRoomQuestionModal(); showBookModal();">
              &larr; Back
            </button>
            <button type="button" class="btn btn-green" @click="roomQuestionsToPayModalClicked">
              Next Step
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- .modal roomQuestionModal-->

    <pay-handler
      ref="payComponent"
      :location="location"/>

  </div>
</template>

<script>
import {Address} from 'address-rfc2821';

export default {
  props: {
    location: {
      type: Object,
      required: true,
    },
    saleFrom: {
      type: String,
      default: 'R',
    },
    locationDiscount: {
      type: Object,
    },
    brand: {
      type: String,
    },
    initialCart: {
      type: Object,
      required: true,
    },
    locationChildPricing: {
      type: Boolean,
    },
    adultPricingNotPlayerPricing: {
      type: Boolean,
    },
    bookingLabelAdults: {
      type: String,
      default: 'Adults',
    },
    bookingLabelAdultsSelection: {
      type: String,
      default: 'Select number of adults',
    },
    bookingChildCaveat: {
      type: String,
      default: 'Minimum of 2 adult tickets per game, regardless of age. A child is defined as 15 or younger.',
    },
    customerRequestMarketingPermission: {
      type: Boolean,
    },
    paymentProvider: {
      type: String,
    },
    pricingStyle: {
      type: String,
      default: 'DEFAULT',
    },
  },

  data() {
    return {
      cart: Vue.util.extend({}, JSON.parse(JSON.stringify(this.initialCart))),

      startTime: null,  // fraud|bot check

      roomSlot: null,
      state: null,

      virtualGame: null,

      customerId: null,
      payButtonDisable: false,

      // bookModal v-models
      email: null,
      name: null,
      username: null, // for spam detection
      contactNumber: null,
      marketingConsent: false,

      numberOfAdults: 0,
      numberOfChildren: 0,

      roomQuestionResponses: {},
      roomQuestionResponseErrors: null,

      // validation errors
      emailError: false,
      emailSoftError: false,
      nameError: false,
      numberOfPlayersError: '',
      numberOfAdultsError: '',
      numberOfChildrenError: '',

      customerId: null,
      customerName: null,
      customerEmail: null,

      asPendingError: false,

      roomQuestionResponseError: {},

      // lockModal v-models
      lockError: false,
      lockEmail: null,
      retryRoomSlot: null,
    };
  },

  computed: {
    numberOfPlayers() {
      return parseInt(this.numberOfAdults) + parseInt(this.numberOfChildren);
    },

    enoughPlayersToProceed() {
      if (this.hasChildPricing) {
        if (this.numberOfPlayers < this.room.play_min) {
          return false;
        }
      }
      return true;
    },

    fromVirtualGame() {
      return this.virtualGame != null;
    },

    room() {
      if (this.roomSlot) {
        return this.location.rooms.find(room => room.id == this.roomSlot.room_id);
      } else if (this.virtualGame) {
        return this.location.virtual_games.find(room => room.id == this.virtualGame.id);
      }

      return null;
    },

    /**
     * Gives the rooms slot start and end time in the format "h:mm a - h:mm a".
     *
     * @return {string}
     */
    roomSlotTimeText() {
      if (this.roomSlot) {
        return moment(this.roomSlot.start).format('h:mm a') + ' - ' + moment(this.roomSlot.end).format('h:mm a');
      }

      return '';
    },

    /**
     * Text for confirmModal Button
     * @return {string}
     */
    payButtonText() {
      if (this.roomSlot && moment(this.roomSlot.start).isSame(moment(), 'day')) {
        return 'Checkout (today)';
      } else {
        return 'Checkout';
      }
    },

    slotLockLength() {
      if (this.roomSlot
          && ('LOCKED' == this.roomSlot.state || 'BOOKED_PENDING' == this.roomSlot.state)
          && this.roomSlot.activeRoomSlotLock) {
        return moment.duration(
          moment(this.roomSlot.activeRoomSlotLock.expires_at).diff(moment())
          ).humanize();
      }

      return 'some minutes';
    },

    todayDateString() {
      return moment().format('YYYY-MM-DD');
    },

    inPromo() {
      if (this.locationDiscount) {
        if (moment().isBetween(moment(this.locationDiscount.valid_from), moment(this.locationDiscount.expiry))) {
          return true;
        }
      }

      return false;
    },

    contactNumberError() {
      if (this.location.formCustomerNumberRequired === false && this.contactNumber === null) {
        return null;
      } else {
        if (this.contactNumber == '***** ******') {
          return null;
        } else {
          if (this.contactNumber && this.contactNumber
            .match(/^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/)
            // [3]
            // .replace(/ /g,'').match(/^((1[1-9]|2[03489]|3[0347]|5[56]|7[04-9]|8[047]|9[018])\d{8}|(1[2-9]\d|[58]00)\d{6}|8(001111|45464\d))$/)
            ) {
            return null;
          } else {
            return 'Possible invalid phone number.';
          }
        }
      }
    },

    hasChildPricing() {
      // TODO: scope here to make it work for an individual Room
      return this.locationChildPricing;
    },

    numPlayersInputOptions() {
      let options = [];

      if (this.hasChildPricing) {
        if (this.room) {
          for (var num_players = 2; num_players <= parseInt(this.roomSlot.availableRemainingTickets) - parseInt(this.numberOfChildren); num_players++) {
            if (this.adultPricingNotPlayerPricing === true) {
              if (num_players < this.room.play_min) {
                options.push({
                  id: num_players,
                  text: num_players + ' people @ ' + this.$money(this.getPricePerPerson(parseInt(num_players))) + ' pp | ' + this.room.play_min + ' min.',
                });
              } else {
                options.push({
                  id: num_players,
                  text: num_players + ' people @ ' + this.$money(this.getPricePerPerson(parseInt(num_players))) + ' pp',
                });
              }
            } else {
              if (num_players < this.room.play_min) {
                options.push({
                  id: num_players,
                  text: num_players + ' people @ ' + this.$money(this.getPricePerPerson(parseInt(num_players) + parseInt(this.numberOfChildren))) + ' pp | ' + this.room.play_min + ' min.',
                });
              } else {
                options.push({
                  id: num_players,
                  text: num_players + ' people @ ' + this.$money(this.getPricePerPerson(parseInt(num_players) + parseInt(this.numberOfChildren))) + ' pp',
                });
              }
            }
          }
        }
      } else {
        if (this.room) {
          for (var num_players = this.room.play_min; num_players <= this.roomSlot.availableRemainingTickets; num_players++) {
            if (this.room && this.room.tour === true) {
              options.push({
                id: num_players,
                text: num_players + (num_players == 1 ? ' team ' : ' teams ') + '@ ' + this.$money(this.getPricePerPerson(num_players)),
              })
            } else {
              options.push({
                id: num_players,
                text: num_players + ' people @ ' + this.$money(this.getPricePerPerson(num_players)) + ' per person',
              })
            }
          }
        }
      }

      return options;
    },

    numChildrenInputOptions() {
      let options = [];

      if (this.hasChildPricing) {
        if (this.room) {
          for (var num_children = 0; num_children <= this.roomSlot.availableRemainingTickets - this.numberOfAdults; num_children++) {
          // for (var num_children in this.range(this.room.play_min, this.room.play_max)) {
            if (num_children == 0) {
              var text = '0 children';
            } else if (num_children == 1) {
              var text = '1 child @ ' + this.$money(this.getPricePerChild(num_children));
            } else {
              var text = num_children + ' children @ ' + this.$money(this.getPricePerChild(num_children)) + ' per child';
            }
            options.push({
              id: num_children,
              text: text,
            })
          }
        }
      }

      return options;
    },

    roomQuestionIdsRequired() {
      if (this.room && this.room.room_questions.length) {
        return this.room.room_questions.filter(rq => rq.required == 1).map(rq => rq.id);
      }
      return null;
    },
  },

  methods: {
    /* ===============
     * public methods
     */

    startBooking(roomSlot) {
      this.roomSlot = roomSlot;
      this.retryRoomSlot = null;
      this.startTime = moment(); // fraud|bot check

      if ('AVAILABLE' == roomSlot.state || 'BOOKED_PART' == roomSlot.state) {
        this.resetBookModalInputs();
        this.continueToBooking();
        this.showBookModal();
      } else if ('LOCKED' == roomSlot.state
        || 'BOOKED_PENDING' == roomSlot.state) {
        this.showLockModal();
      }
    },

    startVirtualBooking(virtualGame) {
      console.log('startVirtualBooking', virtualGame);
      this.virtualGame = virtualGame;

      this.resetBookModalInputs();
      this.showBookModal();
    },

    /*
     * END public methods
     * =============== */

    /* ===============
     * bookModal methods
     */

    range(start, end) { // this is for a v-for, it cannot not start at 0, vueIdiots
      return Array(end - start + 1).fill().map((_, idx) => start + idx);
    },

    hideAllModals() {
      this.hideBookModal();
      this.hideLockModal();
      this.hideConfirmModal();
      this.hideRoomQuestionModal();
    },

    hideRoomQuestionModal() {
      $(this.$refs.roomQuestionModal).modal('hide');
    },

    showRoomQuestionModal() {
      // console.log('showRoomQuestionModal');
      $(this.$refs.roomQuestionModal).modal('show');
      $(this.$refs.roomQuestionModal).modal('handleUpdate');
    },

    showBookModal() {
      // Do any prep before showing the modal

      this.state = 'BOOKING';
      $(this.$refs.bookModal).modal('handleUpdate');
      $(this.$refs.bookModal).modal('show');
    },

    hideBookModal() {
      $(this.$refs.bookModal).modal('hide');
    },

    bookModalHidden() {
      // console.log('bookModalHidden');
      this.numberOfPlayersError = '';
      this.emailError = false;
      this.emailSoftError = false;
      this.nameError = false;
    },

    getPrice(num_adults, num_children, voucher = false) {
      console.log('getPrice', num_adults, num_children, voucher);
      var price;

      if (this.fromVirtualGame) {
        let preDiscountPrice = this.virtualGame.price;

        return preDiscountPrice;
      } else if (this.pricingStyle == 'CHILD_TOTAL_PLAYERS') {
        price = {};
        if (this.room && this.room.prices.length) {
          if (num_children) {
            if (this.roomSlot.peakType == 'P') {
              return (this.room.prices.find(price => price.price_for == this.numberOfPlayers).peak * num_adults) + (this.room.prices.find(price => price.price_for == (num_adults + num_children)).peak_child * num_children);
            }
            return (this.room.prices.find(price => price.price_for == this.numberOfPlayers).offpeak * num_adults) + (this.room.prices.find(price => price.price_for == (num_adults + num_children)).offpeak_child * num_children);
          } else {
            if (this.roomSlot.peakType == 'P') {
              return this.room.prices.find(price => price.price_for == num_adults).peak * num_adults;
            }
            return this.room.prices.find(price => price.price_for == num_adults).offpeak * num_adults;
          }
        } else {
          if (num_children) {
            if (this.roomSlot.peakType == 'P') {
              return (this.location.prices.find(price => price.price_for == this.numberOfPlayers).peak * num_adults) + (this.location.prices.find(price => price.price_for == (num_adults + num_children)).peak_child * num_children);
            }
            return (this.location.prices.find(price => price.price_for == this.numberOfPlayers).offpeak * num_adults) + (this.location.prices.find(price => price.price_for == (num_adults + num_children)).offpeak_child * num_children);
          } else {
            if (this.roomSlot.peakType == 'P') {
              return this.location.prices.find(price => price.price_for == num_adults).peak * num_adults;
            }
            return this.location.prices.find(price => price.price_for == num_adults).offpeak * num_adults;
          }
        }

      } else {

        if (this.room && this.room.prices.length) {
          console.log('this.room && this.room.prices.length');
          if (num_children) {
            price = {};
            var priceChildren = this.room.prices.find(price => price.price_for == num_children);

            if (this.adultPricingNotPlayerPricing) {
              var priceAdults = this.room.prices.find(price => price.price_for == num_adults);
            } else {
              var priceAdults = this.room.prices.find(price => price.price_for == this.numberOfPlayers);
            }

            if (typeof(priceAdults) !== 'undefined') {
              if (this.adultPricingNotPlayerPricing) {
                price.peak = parseInt(priceChildren.peak_child) + parseInt(priceAdults.peak);
                price.offpeak = parseInt(priceChildren.offpeak_child) + parseInt(priceAdults.offpeak);
              } else {
                price.peak = parseInt(priceChildren.peak_child) + parseInt(priceAdults.peak / this.numberOfPlayers * num_adults);
                price.offpeak = parseInt(priceChildren.offpeak_child) + parseInt(priceAdults.offpeak / this.numberOfPlayers * num_adults);
              }
            } else {
              console.log('typeof falsey if');
              price.peak = parseInt(priceChildren.peak_child);
              price.offpeak = parseInt(priceChildren.offpeak_child);
            }
            console.log('price at this point', price);
          } else {
            price = this.room.prices.find(price => price.price_for == num_adults);
          }
        }

        if (! price) {
          if (num_children) {
            price = {};
            var priceChildren = this.location.prices.find(price => price.price_for == num_children);
            var priceAdults = this.location.prices.find(price => price.price_for == num_adults);

            if (this.adultPricingNotPlayerPricing) {
              if (typeof(priceAdults) !== 'undefined') {
                price.peak = parseInt(priceChildren.peak_child) + parseInt(priceAdults.peak);
                price.offpeak = parseInt(priceChildren.offpeak_child) + parseInt(priceAdults.offpeak);
              } else {
                price.peak = parseInt(priceChildren.peak_child);
                price.offpeak = parseInt(priceChildren.offpeak_child);
              }
            } else {
              priceAdults = this.location.prices.find(price => price.price_for == this.numberOfPlayers);

              if (typeof(priceAdults) !== 'undefined') {
                price.peak = parseInt(priceChildren.peak_child) + parseInt(priceAdults.peak / this.numberOfPlayers * num_adults);
                price.offpeak = parseInt(priceChildren.offpeak_child) + parseInt(priceAdults.offpeak / this.numberOfPlayers * num_adults);
              } else {
                price.peak = parseInt(priceChildren.peak_child);
                price.offpeak = parseInt(priceChildren.offpeak_child);
              }
            }

          } else {
            price = this.location.prices.find(price => price.price_for == num_adults);
          }
        }

        if (voucher) {
          if (voucher.type == 'P') {
            return price.peak;
          } else {
            return price.offpeak;
          }
        }

        console.log('price', price);

        if (this.roomSlot.peakType == 'P') {
          return price.peak;
        } else {
          return price.offpeak;
        }
      }

    },

    getPricePerPerson(num_players) {
      // console.log('getPricePerPerson', num_players);
      return this.getPrice(num_players, 0) / num_players;
    },

    getPricePerChild(num_children) {
      // console.log('getPricePerChild', num_children);
      return this.getPrice(0, num_children) / num_children;
    },

    resetBookModalInputs() {
      // need to reset this as if a different room is select it might have a different play_max
      this.numberOfAdults = 0;
      this.numberOfChildren = 0;
      // this.email = null;
      // this.name = null;
      // this.contactNumber = null;
    },

    emailBlur() {
      // console.log('emailBlur');
      if (this.customerId !== null && this.email != this.customerEmail) {
        // console.log('emailBlur:forget');
        // you changed the emil address, forgot who we though you where
        this.customerId = null;
        this.customerEmail = null;
        this.customerName = null;
      }

      if (this.email && (this.name == null || this.name == '')) {

        this.emailError = false;
        this.emailSoftError = false;

        try {
          new Address(this.email);
        } catch (error) {
          this.emailError = error.message; // Please enter a valid email address.
          return;
        }
        // console.log('emailBlur:pre searchEmail');
        this.loading(true, this.$refs.bookModal);
        this.searchEmail(this.email)
          .then(customerFound => {
            this.loading(false);
            if (customerFound !== null) {
              this.customerId = customerFound.id;
              this.customerEmail = this.email;
              this.customerName = customerFound.name;
              this.name = this.customerName;
              this.contactNumber = '***** ******';
              this.marketingConsent = ! customerFound.no_mail;
            } else {
              this.$refs.nameInput.focus();
              this.checkRegionalEmail();
            }
          });
      }
    },

    checkRegionalEmail() {
      var regex = /^[\w.+\-]+@([a-zA-Z0-9]+)([\.])(com|co.uk)/gm;
      if (regex.test(this.email)) {
        this.emailSoftError = false;
      } else {
        this.emailSoftError = 'Warning: Email does not end in .co.uk or .com. You may proceed with the booking, this is to highlight you have a non-standard email, or a typo.';
      }
    },

    async searchEmail(emailToSearch) {
      let request = {
        email: emailToSearch,
      }

      try {
        const response = await axios.post(this.route('api.customers.email-lookup'), request);
        if (response.status == 200) {
          return response.data;
        }
      } catch (error) {
        if (error.response) {
          if (error.response.status == 422) { // HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            this.emailError = error.response.data.errors.email[0]; // Please enter a valid email address.
          } else if (error.response.status == 404) {
            this.customerId = null;
            this.customerEmail = null;
            this.customerName = null;
          }
          // console.log('emailBlur: Response error', error.response.data, error.response.status, error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          // console.error('emailBlur: Request error', error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.error('emailBlur: Error', error.message);
        }
      }

      return null;
    },

    respondToRoomQuestionsClick() {
      // console.log('respondToRoomQuestionsClick');

      if (this.location.formCustomerNumberRequired === false && this.contactNumberError) {
        const self = this;

        let options = {
          container: 'body',
          rootSelector: '#roomQuestionResponses',
          title: 'Proceed with unrecognised phone number format?',
          popout: true,
          singleton: true,
          btnOkLabel: 'Continue',
          btnOkClass: 'btn btn-dark-green',
          btnOkIconClass: 'material-icons',
          btnOkIconContent: 'shopping_cart',
          btnCancelLabel: 'Stop!',
          btnCancelClass: 'btn btn-danger',
          btnCancelIconClass: 'material-icons',
          btnCancelIconContent: 'close',
          onConfirm(value) {
            self.respondToRoomQuestionsConfirmed();
          },
        };

        $('#roomQuestionResponses').confirmation(options);
        $('#roomQuestionResponses').confirmation('show');
      } else {
        this.respondToRoomQuestionsConfirmed();
      }
    },

    respondToRoomQuestionsConfirmed() {
      // console.log('respondToRoomQuestionsConfirmed');

      if (! this.antiFraudTestPassed()) {
        // console.log('! antiFraudTestPassed');
        return;
      }

      if (! this.checkCustomerDetails()) {
        // console.log('! checkCustomerDetails');
        return;
      }

      const self = this;
      this.hideBookModal();
      $(this.$refs.bookModal).on('hidden.bs.modal', function (event) {
        self.showRoomQuestionModal();
      });
    },

    confirmPriceClick() {
      console.log('confirmPriceClick');

      if (this.location.formCustomerNumberRequired === false && this.contactNumberError) {
        const self = this;

        let options = {
          container: 'body',
          rootSelector: '#makeBookingConfirmPriceBtn',
          title: 'Proceed with unrecognised phone number format?',
          popout: true,
          singleton: true,
          btnOkLabel: 'Continue',
          btnOkClass: 'btn btn-dark-green',
          btnOkIconClass: 'material-icons',
          btnOkIconContent: 'shopping_cart',
          btnCancelLabel: 'Stop!',
          btnCancelClass: 'btn btn-danger',
          btnCancelIconClass: 'material-icons',
          btnCancelIconContent: 'close',
          onConfirm(value) {
            self.confirmPriceConfirmed();
          },
        };

        $('#makeBookingConfirmPriceBtn').confirmation(options);

        $('#makeBookingConfirmPriceBtn').confirmation('show');
      } else {
        this.confirmPriceConfirmed();
      }
    },

    checkCustomerDetails() {
      if (this.email == null || this.email == '') {
        this.emailError = 'An email address is required.'; // Please enter a valid email address.
      } else {
        this.emailError = false;
        this.emailSoftError = false;

        try {
          new Address(this.email);
        } catch (error) {
          this.emailError = error.message; // Please enter a valid email address.
        }

        // TODO: try looking up the email again?
        this.loading(true);
        this.searchEmail(this.email)
          .then(customerFound => {
            this.loading(false);
            if (customerFound !== null) {
              // LWK what to do?
              this.customerId = customerFound.id;

              if (this.name != customerFound.name || this.contactNumber != '***** ******') {
                // should we update the Customer details?
                // this.updateCustomer();
              }
            } else {
              this.checkRegionalEmail();
            }
          });
      }

      if (this.name == null || this.name == '') {
        this.nameError = 'Please enter your name.';
      } else {
        this.nameError = false;
      }

      if (this.location.formCustomerNumberRequired && this.contactNumberError !== null) {
        this.numberError = 'Please enter a valid number.';
      } else {
        this.numberError = false;
      }

      if (this.numberOfPlayersError != ''
        || this.emailError
        || this.nameError
        || this.numberError) {
        return false;
      }

      return true;
    },

    antiFraudTestPassed() {
      // Anti-fraud #1
      if (moment().diff(this.startTime, 'seconds') < 2) {
        //this is too quick, abort
        this.hideBookModal();
        flash('Contact us if you are having issues.', 'danger');
        return false;
      }

      // Anti-fraud #2
      if (this.username !== null) {
        // a bot has filled in the username
        this.hideBookModal();
        return false;
      }

      // Validation
      if (! this.fromVirtualGame) {
        if (this.numberOfPlayers == 0 || this.numberOfPlayers == null || this.numberOfPlayers == '') {
          this.numberOfPlayersError = 'Number of players not selected.';
        } else {
          this.numberOfPlayersError = '';
        }
      } else {
        this.numberOfPlayersError = '';
      }

      return true;
    },

    confirmPriceConfirmed(fromRoomQuestions = false) {
      if (!this.fromVirtualGame && this.room.room_questions.length == 0 && ! this.antiFraudTestPassed()) {
        return;
      }

      if (! this.checkCustomerDetails()) {
        return;
      }

      const self = this;
      if (fromRoomQuestions) {
        this.hideRoomQuestionModal();
        $(this.$refs.roomQuestionModal).on('hidden.bs.modal', function (event) {
          self.showConfirmModal();
        });
      } else {
        this.hideBookModal();
        $(this.$refs.bookModal).on('hidden.bs.modal', function (event) {
          self.showConfirmModal();
        });
      }
    },

    /*
     * END bookModal methods
     * =============== */

    /* ===============
     * lockModal methods
     */

    showLockModal() {
      // Do any prep before showing the modal

      this.state = 'LOCKED';
      $(this.$refs.lockModal).modal('handleUpdate');
      $(this.$refs.lockModal).modal('show');
    },

    hideLockModal() {
      $(this.$refs.lockModal).modal('hide');
    },

    lockModalHidden() {
      // console.log('lockModalHidden');
      this.lockError = false;
    },

    /*
     * END lockModal methods
     * =============== */

    /* ===============
     * confirmModal methods
     */

    showConfirmModal() {
      // Do any prep before showing the modal
      this.payButtonDisable = false;
      this.asPendingError = false;

      this.state = 'CONFIRMING';
      $(this.$refs.confirmModal).modal('handleUpdate');
      $(this.$refs.confirmModal).modal('show');
    },

    hideConfirmModal() {
      $(this.$refs.confirmModal).modal('hide');
    },

    confirmModalHidden() {
      // console.log('confirmModalHidden');
      if (this.asPendingError) {
        this.$emit('refetch'); // tell the BookingCalendar it needs to refetch the RoomSlots
      }
    },

    lockProceed() {
      // this will most likely come from a BOOKING:PENDING, but could come from a Staff Lock
      // both methods will have a room slot lock
      let request = {
        email: this.lockEmail,
      }
      console.log('lockProceed', request);
      console.log('lockProceed roomSlot.id', this.roomSlot.id);

      if (this.lockEmail === null) {
        flash('An email address must be entered', 'danger');

        return;
      }

      // send this.lockEmail and check if it the person who has the pending booking
      this.loading(true);

      axios.patch(this.route('api.room-slots.continue-booking', this.roomSlot), request)
        .then((response) => {
          this.loading(false);

          if (response.status == 200) {
            // console.log('lockProceedResponse', roomSlot)
            let returnedData = response.data;

            if (returnedData.state == "BOOKED_PENDING") {
              // just redirect the customer to the PBL

              let sale = response.data.sale;
              console.log('axios back');
              console.log('sale', sale);

              window.location.href = response.data.redirect;

            } else if (returnedData.state == "LOCKED") {
              // console.log('is a Locked Slot');

              let roomSlot = response.data.roomSlot;

              this.hideLockModal(); // close this modal

              this.email = this.lockEmail;
              this.emailBlur(); // populate fields
              this.showBookModal(); // open that model
              this.$nextTick(() => {
                this.$refs.numPlayersInput.focus();
              });
            }

          } else {
            flash('Error continuing lockProceed', 'error');
            console.log('lockProceed', response.data);
            console.log('lockProceed', response.status);
            console.log('lockProceed', response.statusText);
          }
        })
        .catch((error) => {
          flash('That email does not match the locked booking.', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('lockProceed:422', error.response.data);
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('lockProceed:409', error.response.data);
              this.asPendingError = 'Sorry this slot is no longer available, please pick another slot.';
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('lockProceed:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('lockProceed:401', error.response.data);
              window.location.reload();
            } else {
              console.log('lockProceed: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('lockProceed: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('lockProceed: Error', error);
          }

          this.loading(false);
        }); // axios
    }, // lockProceed

    destroyRoomSlotLock() {
      let request = {
        email: this.lockEmail,
      }

      console.log('destroyRoomSlotLock', request);

      if (this.lockEmail === null) {
        flash('An email address must be entered.', 'danger');

        return;
      }

      // send this.lockEmail and check if it the person who has the pending booking
      this.loading(true);

      axios.patch(this.route('api.room-slot-locks.check-and-destroy', this.roomSlot.activeRoomSlotLock), request)
        .then((response) => {
          this.loading(false);

          if (response.status == 200) {
            let destroyLockResponse = response.data;

            console.log('destroyLockResponse', destroyLockResponse)

            flash('This lock has been removed', 'success');
            this.$emit('refetch'); // tell the BookingCalendar it needs to refetch the RoomSlots
            this.hideLockModal(); // close this modal
          } else {
            flash('Error destroying RoomSlotLock', 'error');
            console.log('destroyRoomSlotLock', response.data);
            console.log('destroyRoomSlotLock', response.status);
            console.log('destroyRoomSlotLock', response.statusText);
          }
        })
        .catch((error) => {
          flash('That email does not match the locked booking.', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('destroyRoomSlotLock:422', error.response.data);
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('destroyRoomSlotLock:409', error.response.data);
              this.asPendingError = 'Sorry this slot is no longer available, please pick another slot.';
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('destroyRoomSlotLock:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('destroyRoomSlotLock:401', error.response.data);
              window.location.reload();
            } else {
              console.log('destroyRoomSlotLock: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('destroyRoomSlotLock: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('destroyRoomSlotLock: Error', error.message);
          }

          this.loading(false);
        }); // axios
    }, // destroyRoomSlotLock

    continueToBooking() {
      this.payButtonDisable = false;
    }, // continueToBooking

    async storeCustomer() {
      // console.log('storeCustomer');
      // create the customer
      let request = {
        email: this.email,
        name: this.name,
        number: this.contactNumber,
        location_id: this.location.id,
        no_mail: this.marketingConsent ? 0 : 1, // the logic is flipped as we want no_mail in the db
      }

      try {
        const response = await axios.post(this.route('api.customers.store'), request)
        if (response.status == 200) {
            return response.data;
        } else {
          flash('Error creating customer', 'danger');
          console.log('storeCustomer', response.data);
          console.log('storeCustomer', response.status);
          console.log('storeCustomer', response.statusText);
        }
      } catch (error) {
        // flash('Error creating customer', 'danger');
        if (error.response) {
          if (error.response.status == 422) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            console.log('storeCustomer:422', error.response.data);
            // TODO: if The email has already been taken. ???
            if (error.response.data.errors.number) {
              this.loading(false);
              flash('Phone number invalid, cannot proceed ' + error.response.data.errors.number[0]);
             // this.contactNumberError = 'Number is invalid, please resolve.';
              this.hideConfirmModal();
              this.showBookModal();
              this.$ref.customerTelephoneInput.focus();
            } else {
              this.loading(false);
              flash('Unable to store customer. Please check details.');
              this.hideConfirmModal();
              this.showBookModal();
            }
          } else if (error.response.status == 409) {
            // else if HTTP_CONFLICT
            console.log('storeCustomer:409', error.response.data);
          } else if (error.response.status == 403) {
            // else if HTTP_FORBIDDEN on enough permissions
            console.log('storeCustomer:403', error.response.data);
          } else if (error.response.status == 401) {
            // else if HTTP_UNAUTHORIZED not authorized
            console.log('storeCustomer:401', error.response.data);
            window.location.reload();
          } else {
            console.log('storeCustomer: Response error', error.response.data, error.response.status, error.response.headers);
          }

        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.error('storeCustomer: Request error', error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error('storeCustomer: Error', error.message);
        }
      }

      return null;
    },

    addVirtualGameToCart(thenRedirect) {
      // console.log('addRoomSlotToCart');

      let request = {
        location: this.location.slug,
        cartable: 'App\\Models\\VirtualGame:' + this.virtualGame.id,
        quantity: 1,
        soldFor: this.virtualGame.price,
      };

      this.loading(true);
      axios.post(this.route('api.cart-current.cart-items.store'), request)
        .then((response) => {
          // console.log('api.cart-current.cart-items.store axios completed');
           if (response.status == 200) {
            // console.log('this.cart updated', response.data);
            this.cart = response.data;

            flash('Virtual Game added to Cart.','warning');

            this.hideConfirmModal();

            if (thenRedirect) {
              window.location.href = route('location.checkout', this.location);
            }

          } else {
            flash('Error adding RoomSlot to Cart', 'error');
            console.log('cartAddRoomSlot', response.data);
            console.log('cartAddRoomSlot', response.status);
            console.log('cartAddRoomSlot', response.statusText);
          }

          this.loading(false);
          this.payButtonDisable = false;
        })
        .catch((error) => {
          flash('Error adding RoomSlot to Cart', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('cartAddRoomSlot:422', error.response.data);
              if (error.response.data.errors) {
                const errors = error.response.data.errors;

                Object.keys(errors).forEach(function(key) {
                  errors[key].forEach(error => flash(error, 'danger'));
                });
              } else {
                flash(error.response.data, 'danger');
              }
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('cartAddRoomSlot:409', error.response.data);
              flash(error.response.data.message, 'danger');
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('cartAddRoomSlot:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('cartAddRoomSlot:401', error.response.data);
              window.location.reload();
            } else {
              console.log('cartAddRoomSlot: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('cartAddRoomSlot: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('cartAddRoomSlot: Error', error.message);
          }
          this.loading(false);
          this.payButtonDisable = false;
        });
    },

    makeVirtualGameSale(goToCheckout) {
      console.log('makeVirtualGameSale()', goToCheckout);

      let request = {
        customer_id: this.customerId,
        soldFor: this.getPrice(this.numberOfPlayers),
      }

      this.loading(true);

      axios.post(this.route('api.virtual-games.sell', this.virtualGame), request)
        .then((response) => {
          this.loading(false);

          if (response.status == 200) {

            let sale = response.data;

            this.hideConfirmModal();

            this.state = 'TAKING_PAYMENT';
            this.$refs.payComponent.takeVirtualGamePayment(this.virtualGame, sale, this.saleFrom);

          } else {
            flash('Error creating Virtual Game sale', 'error');
            console.log('makeVirtualGameSale', response.data);
            console.log('makeVirtualGameSale', response.status);
            console.log('makeVirtualGameSale', response.statusText);
          }

        })
        .catch((error) => {
          flash('Error making pending Booking', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('makeVirtualGameSale:422', error.response.data);
              flash(error.response.data, 'warning');
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('makeVirtualGameSale:409', error.response.data);
              this.asPendingError = 'Sorry this slot is no longer available, please pick another slot.';
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('makeVirtualGameSale:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('makeVirtualGameSale:401', error.response.data);
              window.location.reload();
            } else {
              console.log('makeVirtualGameSale: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('makeVirtualGameSale: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('makeVirtualGameSale: Error', error.message);
          }

          this.loading(false);
        }); // axios
    }, // makeVirtualGameSale()

    /*
     * END confirmModal methods
     * =============== */

    /* =========================
     * roomQuestionModal methods
     */

    roomQuestionsToPayModalClicked() {
      // console.log('roomQuestionsToPayModalClicked');
      this.roomQuestionResponseErrors = null;

      this.roomQuestionIdsRequired.forEach(rqid => {
        var iteratedId = this.room.room_questions.findIndex(rq => rq.id == rqid);

        if (this.room.room_questions[iteratedId].required == 1) {
          this.$set(this.roomQuestionResponseError, rqid, false);
          if (this.room.room_questions[iteratedId].type == 'CHECKBOX') {
            if (typeof(this.roomQuestionResponses[rqid]) == 'undefined' || this.roomQuestionResponses[rqid] === false) {
              this.$set(this.roomQuestionResponseError, rqid, true);
            }
          } else if (this.room.room_questions[iteratedId].type == 'RADIO' && typeof(this.roomQuestionResponses[rqid]) == 'undefined') {
            this.$set(this.roomQuestionResponseError, rqid, true);
          } else if (typeof(this.roomQuestionResponses[rqid]) == 'undefined' || this.roomQuestionResponses[rqid] == '' || this.roomQuestionResponses[rqid] == null) {
            this.$set(this.roomQuestionResponseError, rqid, true);
          }
        } else {

        }
      });

      if (Object.values(this.roomQuestionResponseError).includes(true)) {
        this.roomQuestionResponseErrors = 'There are Room Question(s) to answer';
        flash(this.roomQuestionResponseErrors, 'danger');
        return false;
      }

      var fromRoomQuestions = true;
      this.confirmPriceConfirmed(fromRoomQuestions);
    },

    /*
     * END roomQuestionModal methods
     * ============================= */

    /* ===============
     * Cart methods
     */

    addToCartButtonClicked(thenRedirect = false) {
      // if (this.roomSlot.description.includes('Academy of Spells') && this.subRoomSelected == 'TBC') {
      //   flash('You must select which SubRoom','danger');
      //   this.$refs.subRoomSelection.focus();

      //   return;
      // }

      // console.log('addToCartButtonClicked');
      this.payButtonDisable = true;

      if (this.customerId && (this.name != this.customerName || this.contactNumber != '***** ******')) {
        // customer has edit their details, what to do?
      }

      // console.log('about to check if the customer exists, if not they will be added');
      if (this.customerId == null) {
        this.loading(true);
        this.searchEmail(this.email)
          .then(customerFound => {
            this.loading(false);
            if (customerFound !== null) {
              // hmm
              this.customerId = customerFound.id;
              if (this.fromVirtualGame) {
                // this.makeVirtualGameSale(thenRedirect);
                this.addCustomerAndVirtualGameToCart(thenRedirect);
              } else {
                // console.log('customer was found', this.customerId);
                this.addCustomerAndRoomSlotToCart(thenRedirect);
              }
            } else {
              this.loading(true);
              this.storeCustomer()
                .then(newCustomer => {
                  this.loading(false);
                  if (newCustomer) {
                    this.customerId = newCustomer.id;
                    if (this.fromVirtualGame) {
                      // this.makeVirtualGameSale(thenRedirect);
                      this.addCustomerAndVirtualGameToCart(thenRedirect);
                    } else {
                      // console.log('customer was stored', this.customerId);
                      this.addCustomerAndRoomSlotToCart(thenRedirect);
                    }
                  } else {
                    // console.log('payButtonClicked: storeCustomerError')
                    this.payButtonDisable = false;
                    return; // some kind of error cause we failed to create the customer
                  }
                });
            }
          });
      } else {
        // Book the slot (as PENDING) this will also create a RoomSlotLock
        // console.log('book');
        if (this.fromVirtualGame) {
          // this.makeVirtualGameSale(thenRedirect);
          this.addCustomerAndVirtualGameToCart(thenRedirect);
        } else {
          this.addCustomerAndRoomSlotToCart(thenRedirect);
        }
      }
    },

    addCustomerToCart() {
      return new Promise(resolve => {
        // console.log('addCustomerToCart');

        let request = {
          location: this.location.slug,
          customer_id: this.customerId,
        }
        // console.log('request', request);

        this.loading(true);
        axios.patch(this.route('api.cart-current.update'), request)
          .then((response) => {
            // console.log('addCustomerToCart axios completed');
            this.loading(false);

            if (response.status == 200) {
              // console.log('this.cart updated', response.data);
              this.cart = response.data;
              flash('Added you as the Cart owner','success');
              resolve(true);
            } else {
              flash('Error adding Customer to Cart', 'error');
              console.log('addCustomerToCart', response.data);
              console.log('addCustomerToCart', response.status);
              console.log('addCustomerToCart', response.statusText);
              resolve(false);
            }

          })
          .catch((error) => {
            flash('Error adding RoomSlot to Cart', 'danger');
            if (error.response) {
              if (error.response.status == 422) {
                // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
                console.log('addCustomerToCart:422', error.response.data);
                if (error.response.data.errors) {
                  const errors = error.response.data.errors;

                  Object.keys(errors).forEach(function(key) {
                    errors[key].forEach(error => flash(error, 'danger'));
                  });
                } else {
                  flash(error.response.data, 'danger');
                }
              } else if (error.response.status == 409) {
                // else if HTTP_CONFLICT
                console.log('addCustomerToCart:409', error.response.data);
                flash(error.response.data.message, 'danger');
              } else if (error.response.status == 403) {
                // else if HTTP_FORBIDDEN on enough permissions
                console.log('addCustomerToCart:403', error.response.data);
              } else if (error.response.status == 401) {
                // else if HTTP_UNAUTHORIZED not authorized
                console.log('addCustomerToCart:401', error.response.data);
                window.location.reload();
              } else {
                console.log('addCustomerToCart: Response error', error.response.data, error.response.status, error.response.headers);
              }
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.error('addCustomerToCart: Request error', error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.error('addCustomerToCart: Error', error.message);
            }
            this.loading(false);
            this.payButtonDisable = false;
            resolve(false);
          });
      });
    },

    async addCustomerAndVirtualGameToCart(thenRedirect) {
      // console.log('addCustomerAndVirtualGameToCart');
      // check if the cart is owned by the customer, if not, make it
      if (this.cart.customer) {
        this.addVirtualGameToCart(thenRedirect);
      } else {
        await this.addCustomerToCart();
        this.addVirtualGameToCart(thenRedirect);
      }
    },

    async addCustomerAndRoomSlotToCart(thenRedirect) {
      // console.log('addCustomerAndRoomSlotToCart');
      // check if the cart is owned by the customer, if not, make it
      if (this.cart.customer) {
        this.addRoomSlotToCart(thenRedirect);
      } else {
        await this.addCustomerToCart();
        this.addRoomSlotToCart(thenRedirect);
      }
    },

    addRoomSlotToCart(thenRedirect) {
      // console.log('addRoomSlotToCart');

      let request = {
        location: this.location.slug,
        cartable: 'App\\Models\\RoomSlot:' + this.roomSlot.id,
        quantity: this.numberOfPlayers,
        options: {
          adults: this.numberOfAdults,
          children: this.numberOfChildren,
          saleFrom: this.saleFrom,
        },
        soldFor: this.getPrice(this.numberOfAdults, this.numberOfChildren),
        notes: this.bookingNotes,
        roomResponses: this.roomQuestionResponses,
      };

      // console.log('api.cart-current.cart-items.store', request);

      this.loading(true);
      axios.post(this.route('api.cart-current.cart-items.store'), request)
        .then((response) => {
          // console.log('api.cart-current.cart-items.store axios completed');
           if (response.status == 200) {
            // console.log('this.cart updated', response.data);
            this.cart = response.data;

            this.roomQuestionResponses = {};
            this.roomQuestionResponseErrors = null;
            this.roomQuestionResponseError = {};

            flash('RoomSlot added to Cart.','warning');

            this.hideConfirmModal();

            if (thenRedirect) {
              window.location.href = route('location.checkout', this.location);
            }

          } else {
            flash('Error adding RoomSlot to Cart', 'error');
            console.log('cartAddRoomSlot', response.data);
            console.log('cartAddRoomSlot', response.status);
            console.log('cartAddRoomSlot', response.statusText);
          }

          this.loading(false);
          this.payButtonDisable = false;
        })
        .catch((error) => {
          flash('Error adding RoomSlot to Cart', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('cartAddRoomSlot:422', error.response.data);
              if (error.response.data.errors) {
                const errors = error.response.data.errors;

                Object.keys(errors).forEach(function(key) {
                  errors[key].forEach(error => flash(error, 'danger'));
                });
              } else {
                flash(error.response.data, 'danger');
              }
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('cartAddRoomSlot:409', error.response.data);
              flash(error.response.data.message, 'danger');
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('cartAddRoomSlot:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('cartAddRoomSlot:401', error.response.data);
              window.location.reload();
            } else {
              console.log('cartAddRoomSlot: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('cartAddRoomSlot: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('cartAddRoomSlot: Error', error.message);
          }
          this.loading(false);
          this.payButtonDisable = false;
        });
    },

    /*
     * END Cart methods
     * =============== */

    /* ===============
     * Echo methods
     */
    echoInitCart() {
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      Echo.channel('booking-calendar.cart.session.' + this.cart.session)
        .listen('BookingCalendar.VirtualRoomSlotAvailabilityForCart', this.virtualRoomSlotAvailabilityForCartEvent);

      Echo.channel('cart.session.' + this.initialCart.session)
        .listen('Cart.CartSaved', this.cartSavedEvent);

      if (this.initialCart.customer) {
        this.customerId = this.initialCart.customer.id;
        this.email = this.initialCart.customer.email;
        this.customerEmail = this.initialCart.customer.email;
        this.name = this.initialCart.customer.name;
        this.customerName = this.initialCart.customer.name;
        this.contactNumber = '***** ******';
      }
    },

    echoDeInitCart() {
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      Echo.leave('cart.session.' + this.initialCart.session);
    },

    cartSavedEvent(event) {
      // console.log('cartSavedEvent(event)', event);
      this.cart = event.cart;
    },

    virtualRoomSlotAvailabilityForCartEvent(event) {
      if (this.roomSlot === null) {
        return;
      }

      var thisRoomSlotOnEcho = event.roomSlots.filter(rs => rs.id == this.roomSlot.id);
      if (thisRoomSlotOnEcho.length) {
        if (thisRoomSlotOnEcho[0].state_string != 'Available' && thisRoomSlotOnEcho[0].state_string != 'In Cart') {
          // console.log('need to cancel this modal');
          this.$emit('room-slot-not-available');
        }
      }
    },

    /*
     * END Echo methods
     * =============== */
  },

  mounted() {
    $(this.$refs.bookModal).on('hidden.bs.modal', this.bookModalHidden);
    $(this.$refs.lockModal).on('hidden.bs.modal', this.lockModalHidden);
    $(this.$refs.confirmModal).on('hidden.bs.modal', this.confirmModalHidden);

    this.$nextTick(() => {
      this.echoInitCart();
    });
  },

  beforeDestroy() {
    this.echoDeInitCart();
  },
}
</script>
